import cookies from "js-cookie";
import { Cookies } from "./constants";

const localAllowedTimeOverride = Number(localStorage.getItem('client_auth_allowed_time_override'));

const ALLOWED_TIME = localAllowedTimeOverride ?  localAllowedTimeOverride : 1000 * 60 * 60;
export interface ActivityTrackerOptions {
	refreshOnInterval?: boolean;
}

export class ActivityTracker {
	private domain: string;
	protected signOut: () => void;

	constructor(options: ActivityTrackerOptions, signOut: () => void) {
		const hostname = window.location.hostname;
		this.domain = hostname.includes('localhost')? 'localhost' : `.${hostname.split('.').slice(-2).join('.')}`;

		this.refreshActivityTimeout();

		window.addEventListener('keydown', () => this.refreshActivityTimeout());
		window.addEventListener('click', () => this.refreshActivityTimeout());


		if (options.refreshOnInterval) {
			setInterval(() => this.refreshActivityTimeout(), 1000 * 60 * 5);
		}

		this.signOut = signOut;
		// Must use annonymous so you have context of .this when called
		setInterval(() => this.checkActivityTimeout(), 10_000);
	}

	private checkActivityTimeout() {
		const activityTimeout = cookies.get(Cookies.activityTimeout);
		if (!activityTimeout || parseInt(activityTimeout) < Date.now()) {
			this.signOut();
		}
	}

	private refreshActivityTimeout() {
		const newActivityTimeout = (Date.now() + ALLOWED_TIME).toString();
		const result = cookies.set(
			Cookies.activityTimeout,
			newActivityTimeout,
			{
				domain: this.domain,
				expires: new Date(Date.now() + ALLOWED_TIME),
			}
		);
	}

}